import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Link } from '../../services/link';

const Ul = styled.ul`
  display: ${(props) => props.isDisplayed ? 'flex' : 'none'};
  flex-direction: column;
  justify-content: space-evenly;
  position: absolute;
  width: fit-content;
  padding: 20px 15px;
  margin: 89px 0px 0px;
  background-color: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.black};
  z-index: 5;
  text-align: left;
  overflow:hidden;
  list-style-type: none;
  border-width: thin;
  border-style: solid;
  border-color: ${({ theme }) => theme.colors.grey50};
  white-space: nowrap;
  right: ${({ right }) => right ? '0px' : 'unset'};
  text-transform: uppercase;

  @media (max-width: ${({ theme }) => theme.tabletThresholdPixels}) {
    margin: 52px 0 0;
    right: ${({ right }) => right ? '-23px' : 'unset'};

  }
`;

const Li = styled.li`
  padding: 8px 0px;
  &:hover {
    opacity: 0.7;
  }
`;

const Span = styled.span`
  font-family: Roboto;
  font-size: 12px;
  text-decoration: none;
  cursor: pointer;

  @media (max-width: ${({ theme }) => theme.tabletThresholdPixels}) {
    text-align: center;
  }
`;

function DropdownList({
  dropdownList, isDisplayed, right,
}) {
  return (
    <Ul isDisplayed={isDisplayed} right={right}>
      {dropdownList.map(({
        url, onClick, text, urlNewTab,
      }) => (
        <Li key={text}>
          {!!url
          && (
            <Link
              to={url}
              style={{ textDecoration: 'none', color: 'inherit' }}
              onClick={() => (typeof onClick === 'function') && onClick()}
            >
              <Span>{text}</Span>
            </Link>
          )}
          {!!urlNewTab
          && (
            <a
              target="_blank"
              style={{ textDecoration: 'none', color: 'inherit' }}
              rel="noreferrer noopener"
              href={urlNewTab}
            >
              <Span>{text}</Span>
            </a>
          )}
        </Li>
      ))}
    </Ul>
  );
}

DropdownList.propTypes = {
  dropdownList: PropTypes.arrayOf(PropTypes.shape({})),
  isDisplayed: PropTypes.bool,
  right: PropTypes.bool,
};

DropdownList.defaultProps = {
  dropdownList: [],
  isDisplayed: false,
  right: false,
};

export default DropdownList;
